import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import RichText from '../../util/RichText';
import { Media } from '../Media/Media';
import getCardDetails from '../../util/getCardDetails';

const MultipleBlogImageContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  ${EmotionBreakpoint('mobile')} {
    .back-to-home {
      margin-left: 25px;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
  .main-container {
    margin-bottom: 2.5rem;
    .inner-container {
      display: flex;
      padding: 1rem 0;
    }
    .content-container {
      width: 70%;
      margin-left: 2rem;
    }
    .media-container {
      width: 25%;
      margin-top: 6px;
    }
  }
`;

const MultipleBlogImageContent = ({ fields }) => {
  console.log('contentReturnfields', fields);

  return (
    <MultipleBlogImageContentContainer>
      <div className="main-container">
        <h2>{fields.title}</h2>
        {fields.blocks.map(item => {
          let imageDetails = getCardDetails(item.fields.blocks);
          const content =
            item?.fields?.blocks && item?.fields?.blocks[0]?.fields?.content
              ? RichText(item?.fields?.blocks[0]?.fields?.content)
              : item?.fields?.content
              ? RichText(item?.fields?.content)
              : null;
          const mobContent =
            item?.fields?.blocks && item?.fields?.blocks[0]?.fields?.mobileContent
              ? RichText(item?.fields?.blocks[0]?.fields?.mobileContent)
              : item?.fields?.mobileContent
              ? RichText(item?.fields?.mobileContent)
              : null;

          const displayContent = window.innerWidth < 768 && mobContent ? mobContent : content;

          return (
            <div className="inner-container">
              <div className="media-container">
                <Media
                  src={imageDetails?.backgroundImage}
                  srcMob={imageDetails?.mobileBackgroundImage}
                  alt={'imageAlt'}
                />
              </div>

              <div className="content-container">{displayContent}</div>
            </div>
          );
        })}
      </div>
    </MultipleBlogImageContentContainer>
  );
};

export { MultipleBlogImageContent };
